import React, { memo } from "react";
import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { navigateToOtherPlatform } from "@/config/platformSwitcher";
import styles from "./PlatformSwitcher.module.scss";

interface PlatformSwitcherProps {
  onClose: () => void;
}

const PlatformSwitcher: React.FC<PlatformSwitcherProps> = ({ onClose }) => {
  return (
    <Box component="section" className={styles.bar} aria-label="Platform switcher">
      <Typography variant="body2" className={styles.info}>
        You can switch between the new and old platforms within this tab.
      </Typography>

      <Box className={styles.actions}>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={navigateToOtherPlatform}
        >
          Switch to Old Platform
        </Button>
      </Box>

      <Tooltip title="Close">
        <IconButton size="small" onClick={onClose} aria-label="Close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default memo(PlatformSwitcher);
